import React from "react";
import uploadIMage from "../../Assets/icon/uploadIconNew.png";
import faceNetImage from "../../Assets/icon/livenessMapIcon/1.svg";
import cameraImage from "../../Assets/icon/mobileCameraIcon.png";
import CircularProgress from "../UI/CircularProgress";
import LinearProgressComponent from './LinearProgressComponent';
export default function ProcessingIcon(props: any){
    const renderSwitch = (param: any) => {
        switch(param) {
            case 'uploading':
                return <CircularProgress image={uploadIMage} />;
            case 'faceNetProcessing':
                return <CircularProgress image={faceNetImage} />;
            case 'detectedCamera':
                return <CircularProgress image={cameraImage} />;
            default:
                return <LinearProgressComponent />;
        }
    }
    return (
        <>
            { renderSwitch(props.value) }
        </>
    )
}
